// Catalogue de tarification PROGÈRE CORE — prix, limites et Price IDs Stripe.
// Chaque plan référence la variable d'environnement Stripe correspondante (à configurer).

export const PRICING = [
  {
    key: "punch",
    name: "PROGÈRE PUNCH",
    subtitle: "Gestion du temps, punch mobile, géofence et feuilles de temps",
    stripe_product: "PROGERE_PUNCH",
    plans: [
      {
        tier: "starter", label: "Starter", price: "79,00", priceEnv: "PROGERE_PUNCH_STARTER_PRICE_ID",
        features: ["3 utilisateurs", "Jusqu'à 10 employés", "Punch mobile avec géofence", "Feuilles de temps automatiques", "Approbations de base", "Export CSV", "Punch AI : 10 analyses/mois"],
      },
      {
        tier: "pro", label: "Pro", price: "199,00", priceEnv: "PROGERE_PUNCH_PRO_PRICE_ID", popular: true,
        features: ["10 utilisateurs", "Jusqu'à 40 employés", "Tout Starter", "Approbations multi-niveaux", "Exports CSV / Excel / PDF / JSON", "Punch AI : 100 analyses/mois", "Rapports avancés et budgets", "Rôles et permissions complets"],
      },
      {
        tier: "enterprise", label: "Entreprise", price: "399,00", priceEnv: "PROGERE_PUNCH_ENTERPRISE_PRICE_ID",
        features: ["Utilisateurs illimités", "Employés illimités", "Tout Pro", "Chantiers illimités", "Punch AI illimité", "Intégrations : QuickBooks, Acomba, Sage", "Export SFTP sécurisé", "Audit log et conformité Loi 25 avancée"],
      },
    ],
  },
  {
    key: "crm",
    name: "PROGÈRE CRM",
    subtitle: "Gestion des clients, ventes, suivis et pipeline",
    stripe_product: "PROGERE_CRM",
    plans: [
      {
        tier: "starter", label: "Starter", price: "69,00", priceEnv: "PROGERE_CRM_STARTER_PRICE_ID",
        features: ["3 utilisateurs", "Jusqu'à 250 contacts", "1 pipeline de vente", "Gestion clients et prospects", "Tâches et suivis de base", "Notes clients", "Historique des communications", "Rappels manuels", "Export CSV"],
      },
      {
        tier: "pro", label: "Pro", price: "149,00", priceEnv: "PROGERE_CRM_PRO_PRICE_ID", popular: true,
        features: ["10 utilisateurs", "Jusqu'à 2 500 contacts", "Pipelines illimités", "Automatisations de relance", "Suivis par courriel", "Devis reliés aux clients", "Tableau de bord des ventes", "Rapports de performance", "Import/export Excel, CSV et PDF", "CRM AI : 100 analyses/mois"],
      },
      {
        tier: "enterprise", label: "Entreprise", price: "299,00", priceEnv: "PROGERE_CRM_ENTERPRISE_PRICE_ID",
        features: ["Utilisateurs illimités", "Contacts illimités", "Tout Pro", "Automatisations avancées", "Segmentation client avancée", "Intégration PUNCH, ERP et COMPTA", "CRM AI illimité", "Rôles et permissions avancés", "Audit log complet", "Gestion multi-compagnies"],
      },
    ],
  },
  {
    key: "erp",
    name: "PROGÈRE ERP",
    subtitle: "Gestion complète des projets, chantiers et opérations",
    stripe_product: "PROGERE_ERP",
    construction: true,
    plans: [
      {
        tier: "starter", label: "Starter", price: "129,00", priceEnv: "PROGERE_ERP_STARTER_PRICE_ID",
        features: ["3 utilisateurs", "Jusqu'à 3 projets actifs", "Gestion de projets", "Gestion des chantiers", "Tâches et échéanciers de base", "Documents de projet", "Rapports journaliers simples", "Suivi des directives", "Export PDF"],
      },
      {
        tier: "pro", label: "Pro", price: "299,00", priceEnv: "PROGERE_ERP_PRO_PRICE_ID", popular: true,
        features: ["10 utilisateurs", "Jusqu'à 15 projets actifs", "Tout Starter", "Gestion avancée des projets", "Échéanciers et phases", "Suivi des budgets", "Bons de commande", "Directives et QRT", "Rapports journaliers avancés", "Approbations internes", "ERP AI : 100 analyses/mois"],
      },
      {
        tier: "enterprise", label: "Entreprise", price: "599,00", priceEnv: "PROGERE_ERP_ENTERPRISE_PRICE_ID",
        features: ["Utilisateurs illimités", "Projets illimités", "Tout Pro", "Gestion multi-chantiers", "Tableaux de bord exécutifs", "Approbations multi-niveaux", "Gestion des sous-traitants", "Journal de chantier complet", "Audit log avancé", "ERP AI illimité", "Intégration CRM, PUNCH, COMPTA et DEVIS AI"],
      },
    ],
  },
  {
    key: "compta",
    name: "PROGÈRE COMPTA",
    subtitle: "Facturation, dépenses, taxes, export comptable et option paie intégrée",
    stripe_product: "PROGERE_COMPTA",
    construction: true,
    note: "PROGÈRE PAIE est une option intégrée à PROGÈRE COMPTA. Elle peut être ajoutée à l'abonnement mensuel selon le forfait choisi.",
    plans: [
      {
        tier: "starter", label: "Starter", price: "79,00", priceEnv: "PROGERE_COMPTA_STARTER_PRICE_ID",
        features: ["2 utilisateurs", "Jusqu'à 50 factures/mois", "Création de factures", "Suivi des paiements", "Gestion des dépenses de base", "Taxes TPS/TVQ", "Export CSV", "Tableau de bord simple"],
        payroll: { name: "PROGÈRE PAIE Starter", price: "49,00", priceEnv: "PROGERE_COMPTA_PAIE_STARTER_ADDON_PRICE_ID", features: ["Jusqu'à 15 employés", "Préparation des heures de paie", "Validation des feuilles de temps", "Employés CCQ et non-CCQ", "Export CSV", "Historique des périodes de paie"] },
      },
      {
        tier: "pro", label: "Pro", price: "199,00", priceEnv: "PROGERE_COMPTA_PRO_PRICE_ID", popular: true,
        features: ["8 utilisateurs", "Jusqu'à 300 factures/mois", "Tout Starter", "Bons de commande", "Comptes recevables", "Comptes payables", "Rapports financiers", "Export PDF / Excel / CSV", "Intégration QuickBooks, Acomba ou Sage", "COMPTA AI : 100 analyses/mois"],
        payroll: { name: "PROGÈRE PAIE Pro", price: "99,00", priceEnv: "PROGERE_COMPTA_PAIE_PRO_ADDON_PRICE_ID", features: ["Jusqu'à 60 employés", "Validation multi-niveaux", "Export paie avancé", "Rapports CCQ", "Connexion avec PROGÈRE PUNCH", "Gestion des banques d'heures", "Gestion des primes", "PAIE AI : 100 analyses/mois"] },
      },
      {
        tier: "enterprise", label: "Entreprise", price: "399,00", priceEnv: "PROGERE_COMPTA_ENTERPRISE_PRICE_ID",
        features: ["Utilisateurs illimités", "Factures illimitées", "Tout Pro", "Multi-compagnies", "Approbations de dépenses", "Rapports financiers avancés", "Export comptable avancé", "Audit log complet", "COMPTA AI illimité", "Intégration ERP, CRM et PUNCH"],
        payroll: { name: "PROGÈRE PAIE Entreprise", price: "149,00", priceEnv: "PROGERE_COMPTA_PAIE_ENTERPRISE_ADDON_PRICE_ID", features: ["Employés illimités", "Rapports CCQ avancés", "Export vers logiciels comptables", "Gestion multi-compagnies", "Audit complet des modifications", "PAIE AI illimité", "Intégration PUNCH, COMPTA et ERP"] },
      },
    ],
  },
  {
    key: "devis-ai",
    name: "PROGÈRE DEVIS AI",
    subtitle: "Soumissions, estimations, prix et documents clients",
    stripe_product: "PROGERE_DEVIS_AI",
    construction: false,
    note: "Option disponible — PROGÈRE TAKEOFF intégré : importez vos plans PDF, calculez vos quantités et envoyez les résultats directement dans PROGÈRE DEVIS AI pour des soumissions plus rapides et précises. Disponible uniquement avec PROGÈRE DEVIS AI, au même palier.",
    plans: [
      {
        tier: "starter", label: "Starter", price: "99,00", priceEnv: "PROGERE_DEVIS_AI_STARTER_PRICE_ID",
        features: ["2 utilisateurs", "Jusqu'à 25 soumissions/mois", "Création de soumissions", "Modèles de devis", "Export PDF", "Catalogue de services", "Calculs de base", "Devis AI : 25 générations/mois"],
        takeoff: { construction: true, name: "PROGÈRE TAKEOFF Starter", price: "129,00", priceEnv: "PROGERE_DEVIS_AI_TAKEOFF_STARTER_ADDON_PRICE_ID", features: ["Jusqu'à 10 plans/mois", "Import de plans PDF", "Mesures de base", "Calcul des surfaces", "Calcul des longueurs", "Export simple", "Takeoff AI : 10 analyses/mois", "Envoi des quantités vers vos soumissions DEVIS AI"] },
      },
      {
        tier: "pro", label: "Pro", price: "249,00", priceEnv: "PROGERE_DEVIS_AI_PRO_PRICE_ID", popular: true,
        features: ["8 utilisateurs", "Jusqu'à 150 soumissions/mois", "Tout Starter", "Devis détaillés par section", "Marges et profits", "Matériaux et main-d'œuvre", "Conversion devis vers projet ERP", "Suivi des soumissions acceptées/refusées", "Devis AI : 250 générations/mois"],
        takeoff: { construction: true, name: "PROGÈRE TAKEOFF Pro", price: "299,00", priceEnv: "PROGERE_DEVIS_AI_TAKEOFF_PRO_ADDON_PRICE_ID", features: ["Jusqu'à 75 plans/mois", "Métrés avancés", "Quantités par pièce, étage ou zone", "Liste de matériaux", "Export Excel / PDF", "Takeoff AI : 100 analyses/mois", "Envoi automatique des quantités vers DEVIS AI"] },
      },
      {
        tier: "enterprise", label: "Entreprise", price: "499,00", priceEnv: "PROGERE_DEVIS_AI_ENTERPRISE_PRICE_ID",
        features: ["Utilisateurs illimités", "Soumissions illimitées", "Tout Pro", "Devis AI illimité", "Modèles personnalisés par entreprise", "Analyse automatique des marges", "Comparaison de prix", "Approbations internes", "Intégration CRM, ERP et COMPTA", "Audit log complet"],
        takeoff: { construction: true, name: "PROGÈRE TAKEOFF Entreprise", price: "599,00", priceEnv: "PROGERE_DEVIS_AI_TAKEOFF_ENTERPRISE_ADDON_PRICE_ID", features: ["Plans illimités", "Takeoff AI illimité", "Comparaison de plans", "Révisions et versions", "Quantités avancées par système", "Synchronisation complète avec DEVIS AI", "Audit log complet", "Support prioritaire"] },
      },
    ],
  },
];

// PROGÈRE SUPPORT n'est PAS un module payant : il est inclus dans tous les forfaits.
// C'est la zone pour parler à un technicien et poser toute question.
export const SUPPORT_INCLUDED = {
  key: "support",
  name: "PROGÈRE SUPPORT",
  subtitle: "Parlez à un technicien et posez toutes vos questions — inclus dans tous les forfaits.",
  features: [
    "Parlez directement à l'un de nos techniciens",
    "Assistant IA disponible 24/7",
    "Création et suivi de billets de support",
    "Centre d'aide et documentation",
    "Aucun frais supplémentaire",
  ],
};

export const PROGERE_360 = {
  key: "360",
  name: "PROGÈRE 360",
  subtitle: "Écosystème complet",
  stripe_product: "PROGERE_360",
  priceEnv: "PROGERE_360_CUSTOM_PRICE_ID",
  includes: [
    "PROGÈRE (portail central)", "PROGÈRE PUNCH", "PROGÈRE CRM", "PROGÈRE ERP",
    "PROGÈRE COMPTA", "PROGÈRE PAIE intégrée", "PROGÈRE DEVIS AI",
    "PROGÈRE TAKEOFF", "PROGÈRE SUPPORT",
  ],
  benefits: [
    "Utilisateurs illimités", "Employés illimités", "Projets illimités",
    "Modules illimités", "ERP unifié", "Connexion complète entre tous les modules",
    "SSO centralisé", "Gestion multi-compagnies", "Formation incluse",
    "Déploiement accompagné", "Gestionnaire de compte dédié", "Support prioritaire",
  ],
};

// Icône lucide par module pour l'affichage
export const PRICING_ICONS = {
  punch: "Clock",
  crm: "Users",
  erp: "Boxes",
  compta: "Calculator",
  "devis-ai": "Sparkles",
  takeoff: "Ruler",
  support: "LifeBuoy",
};
